<div class="counts" *ngIf="accountingCounts">
  <mat-expansion-panel class="count-panel" [hideToggle]="true">
    <mat-expansion-panel-header class="header">
      <mat-panel-title class="panel-title"
        >Accounting Counts
        <span>{{ accountingCounts.total }}</span></mat-panel-title
      >
    </mat-expansion-panel-header>
    <div class="panel-body">
      <div
        class="panel-item"
        [routerLink]="[
          'counts/list',
          'accountingCounts',
          'projectsNeedingPayment'
        ]"
      >
        <p class="count">Projects Needing Payment Collected</p>
        <span>{{ accountingCounts.projectsNeedingPayment }}</span>
      </div>
    </div>
  </mat-expansion-panel>
</div>
